module.exports = __webpack_public_path__ + "img/system.3acbce3c.svg";